import { Button, ButtonProps } from "../Button/Button";

type IconType = React.FunctionComponent<
    React.ComponentProps<"svg"> & { title?: string }
>

export const IconButton = ({ Icon, ...props }: { Icon: IconType } & Omit<ButtonProps, 'children'>) => (
    <Button {...props} >{<Icon />}</Button>
)
